import { OnrideMusic } from "../music/OnrideMusic";
import { RegionMusic } from "../music/RegionMusic";
import { SoundEffect } from "../music/SoundEffect";

export const audio_engine = {
  music_volume: 0.5 as number,
  effect_volume: 0.5 as number,
  sound_effects: [] as SoundEffect[],
  onride_sound: null as null | OnrideMusic,
  region_sounds: [] as RegionMusic[],
  current_region_music: null as RegionMusic | null,
  current_region_name: null as string | null,
};
